// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text[data-v-21c068fa] {\r\n  color: #888;\r\n  font-size: 0.7rem;\n}\n.notEditable[data-v-21c068fa] {\r\n  color: #f78129;\r\n  font-size: 0.6rem;\n}\n.input[data-v-21c068fa] {\r\n  font-size: 0.8rem;\r\n  font-weight: bold;\n}\n.button[data-v-21c068fa] {\r\n  font-size: 0.7rem;\n}\n@media (max-width: 372px) {\n.input[data-v-21c068fa] {\r\n    max-width: 46%;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
